var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Web_1920_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 43
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_1920_1",
    "data-name": "Web 1920 \\u2013 1",
    clipPath: "url(#clip-Web_1920_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 43,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1651",
    "data-name": "Group 1651",
    transform: "translate(-458 -809)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(466 814)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1551",
    "data-name": "Group 1551",
    transform: "translate(476 826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4128",
    "data-name": "Path 4128",
    d: "M142.892,169.707a.819.819,0,0,0-1.158,0l-7.23,7.23-3.806-3.806a.819.819,0,0,0-1.158,1.158l4.385,4.385a.819.819,0,0,0,1.158,0l7.809-7.809A.819.819,0,0,0,142.892,169.707Z",
    transform: "translate(-129.301 -169.467)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.aa1d192fb26313ad835df99bb52bb083.svg";
export { ForwardRef as ReactComponent };